// ROUTES
export const ROUTE_LIST = 'admin2.vendor.list';
export const ROUTE_CREATE = 'admin2.vendor.create';
export const ROUTE_UPDATE = 'admin2.vendor.update';

// STORAGE KEYS
export const VENDOR_LIST_STORAGE_KEY = 'admin-vendor-list';
export const VENDOR_LIST_VIEW_KEY = 'tv-admin-vendor-list';
